import {canUseDOM} from '@dnd-kit/utilities';

export function isDocumentScrollingElement(element: Element | null) {
  if (!canUseDOM || !element) {
    return false;
  }

  return element === document.scrollingElement;
}



// WEBPACK FOOTER //
// ../src/utilities/scroll/documentScrollingElement.ts